import { financialAccountRepository } from '@webapp/platform/banking/data-access/repositories/FinancialAccountRepository'
import { GetTransfersAuthCodeUseCase } from './GetTransfersAuthCodeUseCase'

export const getTransfersAuthCodeUseCase = new GetTransfersAuthCodeUseCase({
  financialAccountRepository,
}).execute
